module.exports = __webpack_public_path__ + "img/loading-page.388d6f1f.png";